import React,{ useState } from 'react'
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExport,faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

function SettingNavbar(props) {
    const [display, setDisplay] = useState(false);
    const toggleClickHandler = () => {
        setDisplay(!display)
    }

    return <nav className="navbar navbar-expand-lg navbar-light p-0 my-3">
        <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav custom-tabs dashboard-navbar">
                <li className="nav-item">
                    <Link
                        to="/admindashboard/settings/backup"
                        className={
                            "nav-link " + (props.activeTab === "backup" ? "active" : "")
                        }
                        aria-current="page"
                        href="#"
                    >
                        <i className="fa fa-database"></i> BACKUPS
                    </Link>
                </li>

                <li className="nav-item">
                    <Link
                        to="/admindashboard/settings/smtp"
                        className={"nav-link " + (props.activeTab === "smtp" ? "active" : "")}
                        aria-current="page"
                        href="#"
                    >
                        <FontAwesomeIcon icon={faFileExport} /> SMTP
                    </Link>
                </li>

                <li className="nav-item">
                    <Link
                        to="/admindashboard/settings/backuplocation"
                        className={
                            "nav-link " +
                            (props.activeTab === "backupLocation" ? "active" : "")
                        }
                        aria-current="page"
                        href="#"
                    >
                        <i className="fa fa-database"></i> REMOTE BACKUP LOC.
                    </Link>
                </li>

                <li className="nav-item">
                    <Link
                        to="/admindashboard/settings/cloudcredentials"
                        className={
                            "nav-link " +
                            (props.activeTab === "cloudcredentials" ? "active" : "")
                        }
                        aria-current="page"
                        href="#"
                    >
                        <i className="fa fa-dropbox"></i> Cloud Credentials
                    </Link>
                </li>

                {/* <li className="nav-item">
                    <Link
                        to="/admindashboard/settings/billboardRef"
                        className={
                            "nav-link " + (props.activeTab === "billboardRef" ? "active" : "")
                        }
                        aria-current="page"
                        href="#"
                    >
                        <i className="fa fa-clock-o"></i> Billboard Refresh
                    </Link>
                </li> */}

                {/* <li className="nav-item">
                    <Link
                        to="/admindashboard/settings/csvFileRefreshTime"
                        className={"nav-link " + (props.activeTab === "csvFileRefreshTime" ? "active" : "")}
                        aria-current="page"
                        href="#"
                    >
                        <i className="fa fa-clock-o"></i> CsvFile Sync Time
                    </Link>
                </li> */}

                <li className="nav-item">
                    <Link
                        to="/admindashboard/settings/GetRecordOfSingleUser"
                        className={"nav-link " + (props.activeTab === "GetRecordOfSingleUser" ? "active" : "")}
                        aria-current="page" href="#">
                        <i className="fa fa-database" /> Customer Backup
                    </Link>
                </li>

                <li className="nav-item">
                    <Link
                        to="/admindashboard/settings/userActionReport"
                        className={"nav-link " + (props.activeTab === "userActionReport" ? "active" : "")}
                        aria-current="page"
                        href="#"
                    >
                        <i className="fa fa-file"></i> Deleted Users Report
                    </Link>
                </li>
                {/* <li className="nav-item">
                    <Link
                        to="/admindashboard/settings/licenseinfo"
                        className={"nav-link " + (props.activeTab === "licenseinfo" ? "active" : "")}
                        aria-current="page"
                        href="#"
                    >
                        <i className="fa fa-file"></i> License Info
                    </Link>
                </li> */}
                {/* <li className="nav-item">
                    <Link
                        to="/admindashboard/settings/timezones"
                        className={"nav-link " + (props.activeTab === "timezones" ? "active" : "")}
                        aria-current="page"
                        href="#"
                    >
                        <i className="fa fa-clock-o"></i> Time Zone
                    </Link>
                </li> */}
                <li className="nav-item">
                    <Link
                        to="/admindashboard/settings/NasMedia"
                        className={"nav-link " + (props.activeTab === "NasMedia" ? "active" : "")}
                        aria-current="page" href="#">
                        <i className="fa fa-database" /> Cloud Storage
                    </Link>
                </li>

            </ul>
        </div>
        <Dropdown isOpen={display} toggle={toggleClickHandler} className='navSlider-dropdown'>
            <DropdownToggle caret>
                <FontAwesomeIcon icon={faEllipsisV} />
            </DropdownToggle>
            <DropdownMenu>
                {/* <DropdownItem>
                    <Link
                        to="/admindashboard/settings/backup"
                        className={
                            "nav-link " + (props.activeTab === "backup" ? "active" : "")
                        }
                        aria-current="page"
                        href="#"
                    >
                        <i className="fa fa-database"></i> BACKUPS
                    </Link>
                </DropdownItem> */}
                {/* <DropdownItem>
                    <Link
                        to="/admindashboard/settings/backuplocation"
                        className={
                            "nav-link " + (props.activeTab === 'backupLocation' ? "active" : "")
                        }
                        aria-current="page"
                        href="#zz"
                    >
                        <FontAwesomeIcon icon={faFileExport} />
                        REMOTE BACKUP LOC.
                    </Link>
                </DropdownItem> */}
                {/* <DropdownItem>
                    <Link
                        to="/admindashboard/settings/cloudcredentials"
                        className={
                            "nav-link " + (props.activeTab === "cloudcredentials" ? "active" : "")
                        }
                        aria-current="page"
                        href="#"
                    >
                        <i className="fa fa-calendar"></i>
                        Cloud Credentials
                    </Link>
                </DropdownItem> */}
                <DropdownItem>
                    <Link
                        to="/admindashboard/settings/billboardRef"
                        className={
                            "nav-link " + (props.activeTab === "billboardRef" ? "active" : "")
                        }
                        aria-current="page"
                        href="#"
                    >
                        <i className="fa fa-bell"></i>
                        Billboard Refresh
                    </Link>
                </DropdownItem>
                <DropdownItem>
                    <Link
                        to="/admindashboard/settings/csvFileRefreshTime"
                        className={
                            "nav-link " +
                            (props.activeTab === "csvFileRefreshTime" ? "active" : "")
                        }
                        aria-current="page"
                        href="#"
                    >
                        <i class="fa fa-file"></i>
                        CsvFile Sync Time
                    </Link>
                </DropdownItem>
                {/* <DropdownItem>
                    <Link
                        to="/admindashboard/settings/GetRecordOfSingleUser"
                        className={
                            "nav-link " + (props.activeTab === "GetRecordOfSingleUser" ? "active" : "")
                        }
                        aria-current="page"
                        href="#"
                    >
                        <i className="fa fa-database"></i>
                        Customer Backup
                    </Link>
                </DropdownItem> */}
                {/* <DropdownItem>
                    <Link
                        to="/admindashboard/settings/userActionReport"
                        className={
                            "nav-link " + (props.activeTab === "userActionReport" ? "active" : "")
                        }
                        aria-current="page"
                        href="#"
                    >
                        <i className="fa fa-database"></i>
                        Deleted Users Report
                    </Link>
                </DropdownItem> */}
                <DropdownItem>
                    <Link
                        to="/admindashboard/settings/licenseinfo"
                        className={
                            "nav-link " +
                            (props.activeTab === "licenseinfo" ? "active" : "")
                        }
                        aria-current="page"
                        href="#"
                    >
                        <i className="fa fa-dropbox"></i> License Info
                    </Link>
                </DropdownItem>
                <DropdownItem>
                    <Link
                        to="/admindashboard/settings/timezones"
                        className={
                            "nav-link " +
                            (props.activeTab === "timezones" ? "active" : "")
                        }
                        aria-current="page"
                        href="#"
                    >
                        <i className="fa fa-bell"></i>
                        Time Zone
                    </Link>
                </DropdownItem>
                {/* <DropdownItem>
                    <Link
                        to="/admindashboard/settings/NasMedia"
                        className={"nav-link " + (props.activeTab === "NasMedia" ? "active" : "")}
                        aria-current="page" href="#">
                        <i className="fa fa-database" /> Nas media
                    </Link>
                </DropdownItem> */}
            </DropdownMenu>
        </Dropdown>
    </nav>
}

export default SettingNavbar;